// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-widget .card{float:left;width:100%;height:98%}`, "",{"version":3,"sources":["webpack://./resources/app/modules/dashboards/Widgets/ListWidget/index.scss"],"names":[],"mappings":"AAAA,mBACE,UAAA,CACA,UAAA,CACA,UAAA","sourcesContent":[".list-widget .card {\n  float: left;\n  width: 100%;\n  height: 98%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
